import { render, staticRenderFns } from "./NewsAll.vue?vue&type=template&id=74a9de19&scoped=true&"
import script from "./NewsAll.vue?vue&type=script&lang=js&"
export * from "./NewsAll.vue?vue&type=script&lang=js&"
import style0 from "./NewsAll.vue?vue&type=style&index=0&id=74a9de19&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a9de19",
  null
  
)

export default component.exports